import { render, staticRenderFns } from "./DashboardPnet.vue?vue&type=template&id=73122139&scoped=true"
import script from "./DashboardPnet.vue?vue&type=script&lang=js"
export * from "./DashboardPnet.vue?vue&type=script&lang=js"
import style0 from "./DashboardPnet.vue?vue&type=style&index=0&id=73122139&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73122139",
  null
  
)

export default component.exports